(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craft-opening"]) return;
  try {
    
  (() => {
    let current = null;
    let opener = null;
    let first = null;
    let oneAtATime = false;

    const titleOf = (el) => (el ? el.dataset.title || '' : '');

    function hideDeadLinks() {
      document.querySelectorAll('[data-craft-needs]').forEach((el) => {
        const id = el.getAttribute('data-craft-needs');
        const there = id === 'loops' ? Boolean(document.querySelector('wt-video-loop')) : Boolean(document.getElementById(id));
        // A "Made at" label keeps its words when the step it names is
        // switched off; only the link goes.
        if (!there && el.hasAttribute('data-craft-keep-text')) {
          el.replaceWith(document.createTextNode(el.textContent));
          return;
        }
        el.hidden = !there;
      });
    }

    function setCurrent(el) {
      current = el;
      const label = document.querySelector('[data-craft-runhead] [data-craft-current]');
      if (label) label.textContent = el ? titleOf(el) : '';
    }

    function markHere(dialog) {
      dialog.querySelectorAll('[data-craft-goto]').forEach((link) => {
        const here = current && link.getAttribute('data-craft-goto') === current.id;
        const flag = link.querySelector('.craft-contents__here');
        if (here) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
        if (flag) flag.hidden = !here;
      });
    }

    function wireDialog() {
      const dialog = document.getElementById('CraftContents');
      if (!dialog || dialog.dataset.wired || typeof dialog.showModal !== 'function') return;
      dialog.dataset.wired = 'true';

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest && event.target.closest('[data-craft-contents]');
        if (!trigger) return;
        event.preventDefault();
        opener = trigger;
        markHere(dialog);
        dialog.showModal();
        const first = dialog.querySelector('.craft-contents__item:not([hidden]) a');
        if (first) first.focus();
        document.dispatchEvent(new CustomEvent('wildtera:loops', { detail: { pause: true } }));
      });

      dialog.addEventListener('click', (event) => {
        const goto = event.target.closest && event.target.closest('[data-craft-goto]');
        if (goto) {
          // The link itself goes on to the chapter (the router below, or the
          // browser's own jump); the dialog only closes and hands focus on.
          const id = goto.getAttribute('data-craft-goto');
          opener = null;
          dialog.close();
          requestAnimationFrame(() => {
            const title = document.getElementById(id + '-title');
            if (title) title.focus({ preventScroll: true });
          });
          return;
        }
        if (event.target === dialog || (event.target.closest && event.target.closest('[data-craft-close]'))) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', () => {
        if (opener) opener.focus();
        opener = null;
        document.dispatchEvent(new CustomEvent('wildtera:loops', { detail: { pause: false } }));
      });
    }

    function wireChapters() {
      const chapters = Array.from(document.querySelectorAll('[data-craft-chapter]'));
      const runhead = document.querySelector('[data-craft-runhead]');
      const opening = document.querySelector('[data-craft-opening]');
      if (!('IntersectionObserver' in window)) return;

      // With every chapter showing (the theme editor, or no routing), the
      // one in the middle of the screen is the current one.
      if (chapters.length && !oneAtATime) {
        const chapterWatch = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) setCurrent(entry.target);
            });
          },
          { rootMargin: '-30% 0px -60% 0px' }
        );
        chapters.forEach((el) => chapterWatch.observe(el));
      }

      if (runhead && opening) {
        const root = document.documentElement;
        const openingWatch = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const gone = !entry.isIntersecting && entry.boundingClientRect.top < headerHeight();
              if (gone) {
                runhead.hidden = false;
                requestAnimationFrame(() => runhead.classList.add('is-visible'));
                root.classList.add('craft-runhead-on');
              } else {
                runhead.classList.remove('is-visible');
                runhead.hidden = true;
                root.classList.remove('craft-runhead-on');
              }
            });
          },
          // The opening is gone once it has passed under the header.
          { threshold: 0, rootMargin: `-${Math.round(headerHeight())}px 0px 0px 0px` }
        );
        openingWatch.observe(opening);
      }
    }

    /* ---- one chapter at a time ------------------------------------------ */

    // A closed chapter is hidden="until-found" where the browser has it, so
    // find-in-page and a search result's highlighted passage still reach it:
    // the browser fires beforematch and the chapter opens. Elsewhere, hidden.
    const untilFound = 'onbeforematch' in document.documentElement;
    let pending = null;

    // The chapter an address points into, and the element it names: the
    // chapter itself, or a step or a note inside it.
    function find(hash) {
      let id = (hash || '').replace(/^#/, '');
      if (!id) return null;
      try {
        id = decodeURIComponent(id);
      } catch (error) {
        // A malformed escape: look it up as typed.
      }
      const target = document.getElementById(id);
      const chapter = target ? target.closest('[data-craft-chapter]') : null;
      return chapter ? { target, chapter } : null;
    }

    // The chapter a history entry was showing, when it recorded one.
    function kept(state) {
      const el = state && state.craftChapter ? document.getElementById(state.craftChapter) : null;
      return el && el.matches('[data-craft-chapter]') ? el : null;
    }

    function show(chapter) {
      document.querySelectorAll('[data-craft-chapter]').forEach((el) => {
        if (el === chapter) el.removeAttribute('hidden');
        else if (untilFound) el.setAttribute('hidden', 'until-found');
        else el.hidden = true;
      });
      document.querySelectorAll('[data-craft-door]').forEach((door) => {
        door.classList.toggle('is-current', door.getAttribute('data-craft-door') === chapter.id);
      });
      document.querySelectorAll('[data-craft-entry]').forEach((link) => {
        if (link.getAttribute('data-craft-entry') === chapter.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      setCurrent(chapter);
    }

    // The pinned header's measured height (sections/header.liquid).
    function headerHeight() {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wt-header-h')) || 0;
    }

    // A chapter opens at its top edge, just under the pinned header, the
    // opening just out of view so the running head shows; a step or a note
    // opens at itself.
    function land(found) {
      if (found.target === found.chapter) {
        const top = found.chapter.getBoundingClientRect().top + window.scrollY - headerHeight();
        window.scrollTo(0, Math.ceil(top) + 1);
      } else {
        found.target.scrollIntoView({ block: 'start' });
      }
    }

    function focusOn(found) {
      let el = found.target;
      if (el === found.chapter) el = document.getElementById(found.chapter.id + '-title') || el;
      if (!el.matches('a[href], button, input, select, textarea, summary, [tabindex]')) el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    }

    // After Back or Forward has changed the chapter, focus would be left in
    // the one just put away. It goes to the control the reader used on that
    // entry, which is on screen at the place restored; else to the first
    // control on screen; else to the chapter's title.
    function refocus(state) {
      const mark = state && state.craftFocus;
      if (mark && typeof mark.href === 'string') {
        const same = Array.from(document.querySelectorAll('a[href]')).filter((a) => a.getAttribute('href') === mark.href);
        const el = same[mark.n];
        if (el && el.getClientRects().length) {
          el.focus({ preventScroll: true });
          return;
        }
      }
      const scopes = [current, document.querySelector('[data-craft-chooser]')].filter(Boolean);
      for (const scope of scopes) {
        for (const el of scope.querySelectorAll('a[href], button, summary')) {
          const box = el.getBoundingClientRect();
          if (box.height && box.top >= 0 && box.bottom <= window.innerHeight) {
            el.focus({ preventScroll: true });
            return;
          }
        }
      }
      if (current) focusOn({ target: current, chapter: current });
    }

    // Where the reader is, which chapter is open and, when they leave by a
    // link, which link: written into the history entry they are on, so Back,
    // a reload and a return from another page find all three.
    function remember(link) {
      try {
        const state = Object.assign({}, history.state, { craftY: Math.round(window.scrollY) });
        if (current) state.craftChapter = current.id;
        if (link) {
          const href = link.getAttribute('href');
          const same = Array.from(document.querySelectorAll('a[href]')).filter((a) => a.getAttribute('href') === href);
          state.craftFocus = { href, n: same.indexOf(link) };
        }
        history.replaceState(state, '');
      } catch (error) {
        // History can be locked in a sandboxed frame; the place is lost.
      }
    }

    function go(hash) {
      const found = find(hash);
      if (!found || found.chapter === (pending || current)) return;
      pending = found.chapter;
      const swap = () => {
        pending = null;
        remember();
        show(found.chapter);
        try {
          history.pushState({ craftChapter: found.chapter.id }, '', '#' + found.target.id);
        } catch (error) {
          // The chapter still changes; the address does not.
        }
        land(found);
      };
      // A crossfade from the end of one chapter to the start of the next,
      // the same-document form of the hand-over between pages (§4.4).
      if (document.documentElement.classList.contains('wt-motion') && typeof document.startViewTransition === 'function') {
        const transition = document.startViewTransition(swap);
        transition.ready.catch(() => {});
        transition.finished.catch(() => {});
        transition.updateCallbackDone.then(
          () => focusOn(found),
          () => {
            pending = null;
          }
        );
      } else {
        swap();
        focusOn(found);
      }
    }

    function wireRouting() {
      // The theme editor shows every chapter, so each can be edited.
      if (window.Shopify && window.Shopify.designMode) return;
      const chapters = Array.from(document.querySelectorAll('[data-craft-chapter]'));
      if (chapters.length < 2) return;
      oneAtATime = true;
      first = chapters[0];
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

      // A reload or a return from another page shows what the entry last
      // showed, at the place it was left. A fresh arrival shows the chapter
      // its address names, or the first, and goes to the address again,
      // because the browser jumped there before the other chapters were put
      // away.
      const found = find(location.hash);
      const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      const returning = Boolean(nav && (nav.type === 'reload' || nav.type === 'back_forward'));
      const state = history.state;
      const opened = (returning && kept(state)) || (found && found.chapter) || first;
      show(opened);
      if (returning && state && typeof state.craftY === 'number') window.scrollTo(0, state.craftY);
      else if (found && found.chapter === opened) land(found);

      if (untilFound) {
        chapters.forEach((chapter) => {
          chapter.addEventListener('beforematch', () => {
            if (chapter === current) return;
            show(chapter);
            try {
              history.replaceState(Object.assign({}, history.state, { craftChapter: chapter.id }), '', '#' + chapter.id);
            } catch (error) {
              // The chapter still opens.
            }
          });
        });
      }

      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest && event.target.closest('a[href]');
        if (!link || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin) return;
        // Whatever the link does, the entry being left keeps the place, the
        // open chapter and the link, written now rather than when the next
        // page has already replaced this one.
        remember(link);
        if (url.pathname !== location.pathname || !url.hash) return;
        const there = find(url.hash);
        // To the contents, or within the open chapter: the browser's own jump.
        if (!there) return;
        if (there.chapter === pending) {
          event.preventDefault();
          return;
        }
        if (there.chapter === current && !pending) return;
        event.preventDefault();
        go(url.hash);
      });

      window.addEventListener('popstate', (event) => {
        const state = event.state;
        const there = find(location.hash);
        const chapter = kept(state) || (there && there.chapter) || (location.hash ? current : first);
        const changed = Boolean(chapter && chapter !== current);
        if (changed) show(chapter);
        if (state && typeof state.craftY === 'number') window.scrollTo(0, state.craftY);
        else if (there && there.chapter === current) land(there);
        if (changed) refocus(state);
        // An entry the browser made by itself (a hash typed, an in-chapter
        // jump) learns its chapter now.
        if (!kept(state)) remember();
      });

      // A browser that does not fire popstate for a typed hash still opens
      // its chapter.
      window.addEventListener('hashchange', () => {
        const there = find(location.hash);
        if (there && there.chapter !== current) {
          show(there.chapter);
          land(there);
          focusOn(there);
        }
        if (!kept(history.state)) remember();
      });

      // The place is written while reading too, at most twice a second and
      // once more when scrolling stops: Chrome drops a history entry's state
      // written while the page is being left, and Safari refuses more than
      // about a hundred writes in thirty seconds.
      let settle = 0;
      let written = 0;
      window.addEventListener(
        'scroll',
        () => {
          const now = Date.now();
          if (now - written > 500) {
            written = now;
            remember();
          }
          window.clearTimeout(settle);
          settle = window.setTimeout(() => {
            written = Date.now();
            remember();
          }, 250);
        },
        { passive: true }
      );
    }

    function init() {
      if (!document.querySelector('[data-craft-opening]')) return;
      hideDeadLinks();
      wireDialog();
      wireRouting();
      wireChapters();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', hideDeadLinks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The home still and the region panel size themselves to the first screen,
  // which means subtracting this header — and this header is not one height.
  // It is one row at desktop and two below 750px, where the nav wraps under
  // the wordmark, and the width it wraps at depends on how many items the
  // merchant's menu has and how long their labels are. A token cannot know
  // that, so it holds a measured fallback and this replaces it with the truth.
  //
  // Without JS the fallback stands, and it is correct at both ends of the
  // range. Nothing here is required for the page to be usable.
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var apply = function () {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--wt-header-h', h + 'px');
    };

    apply();

    if ('ResizeObserver' in window) {
      new ResizeObserver(apply).observe(header);
    } else {
      window.addEventListener('resize', apply);
    }

    // Webfonts land after first paint and change the wordmark's line box.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-mosaic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-home-mosaic]');
    if (!root) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!root.hasAttribute('data-rotate') || reduce.matches) return;
    if (window.Shopify && window.Shopify.designMode) return;

    const tiles = Array.from(root.querySelectorAll('[data-mosaic-tile]')).filter((tile) =>
      tile.querySelector('template[data-mosaic-next]')
    );
    if (!tiles.length) return;

    const interval = Math.max(5, Number(root.dataset.interval) || 7) * 1000;
    const fade = 1800;
    let visible = true;
    let held = false;
    let next = 0;
    let busy = false;

    // A place's next photograph is put into the page one turn ahead: the
    // first once the page has loaded, each later one as its predecessor
    // comes in. So a place holding four photographs fetches one at a time,
    // behind the visible ones, and never photographs it will not reach.
    const hydrateNext = (tile) => {
      const tpl = tile.querySelector('template[data-mosaic-next]');
      if (tpl) tpl.replaceWith(tpl.content.cloneNode(true));
    };
    const hydrate = () => tiles.forEach(hydrateNext);
    const whenIdle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
    if (document.readyState === 'complete') whenIdle(hydrate);
    else window.addEventListener('load', () => whenIdle(hydrate), { once: true });

    const swap = (from, to) => {
      busy = true;
      to.classList.add('is-entering', 'is-active');
      to.removeAttribute('aria-hidden');
      window.setTimeout(() => {
        from.classList.remove('is-active');
        from.setAttribute('aria-hidden', 'true');
        to.classList.remove('is-entering');
        busy = false;
      }, fade + 50);
    };

    // One place at a time, in turn. A place hidden at this width is skipped,
    // and so is one whose next photograph has not finished loading.
    const step = () => {
      if (busy || held || !visible || document.hidden) return;
      for (let n = 0; n < tiles.length; n += 1) {
        const tile = tiles[(next + n) % tiles.length];
        if (tile.offsetParent === null) continue;
        const layers = Array.from(tile.querySelectorAll('.home-mosaic__layer'));
        if (layers.length < 2) continue;
        const current = Math.max(0, layers.findIndex((layer) => layer.classList.contains('is-active')));
        const incoming = layers[(current + 1) % layers.length];
        const img = incoming.querySelector('img');
        if (img && !(img.complete && img.naturalWidth)) {
          img.loading = 'eager';
          continue;
        }
        swap(layers[current], incoming);
        hydrateNext(tile);
        next = (next + n + 1) % tiles.length;
        return;
      }
    };

    window.setInterval(step, interval);

    root.addEventListener('pointerenter', () => { held = true; });
    root.addEventListener('pointerleave', () => { held = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
      }).observe(root);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy"]) return;
  try {
    
  (function initStickyBuyBar() {
    function start() {
      var trigger = document.querySelector('[data-product-zone="object"]');
      var close = document.querySelector('.product-buy__submit');
      var bars = document.querySelectorAll('.product-buy-sticky');
      if (!trigger || bars.length === 0) return;

      var pastObject = false;
      var closeInView = false;

      function apply() {
        var show = pastObject && !closeInView;
        bars.forEach(function (bar) {
          bar.classList.toggle('product-buy-sticky--visible', show);
          bar.setAttribute('aria-hidden', String(!show));
        });
      }

      // Both observers are held, not left anonymous: an IntersectionObserver
      // with a live target is spec'd to stay alive, but the original kept a
      // reference and there is no reason for this to be the file that finds
      // out whether an engine agrees.
      var objectObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            pastObject = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          });
          apply();
        },
        { threshold: 0 }
      );
      objectObserver.observe(trigger);

      if (close) {
        var closeObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              closeInView = entry.isIntersecting;
            });
            apply();
          },
          // The bar measures 81px, so the close's own button has to clear that
          // much of the viewport floor before it counts as reachable. Without
          // the margin the bar would go while the button it replaces was still
          // underneath where the bar had been.
          { threshold: 0, rootMargin: '0px 0px -96px 0px' }
        );
        closeObserver.observe(close);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
